import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import {FaEdit,FaCircle } from "react-icons/fa";
import { api } from '../../api';
// import { toast } from "react-toastify";
import { customStyles } from "../../styles/dataTableStyles";
import TopUp from "./TopUp";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { decimalTo } from '../../utils/utils'; 

const MerchantList = () => {
  const token = useSelector((state) => state.auth.token);
  const { userType: role } = useSelector((state) => state.auth.user);
  const region = useSelector((state) => state.auth.region);
  const navigate = useNavigate();
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [showTopUp, setShowTopUp] = useState(false)
  // eslint-disable-next-line 
  const [showTopUpHistory, setShowTopUpHistory] = useState(false);
  // eslint-disable-next-line 
  const [showEditMerchantModal, setShowEditMerchantModal] = useState(false);
  // eslint-disable-next-line 
  const [showMerchantInfoModal, setShowMerchantInfoModal] = useState(false);
  const [mid, setMerchentId] = useState(null);
  const [merchantName, setMerchantName] = useState(null);
   // eslint-disable-next-line 
  const [updateData, setUpdateData] = useState(false);


  const topUp = (merchentId,merchantname) => {
    setMerchentId(merchentId)
    setMerchantName(merchantname)
    setShowTopUp(true)
  }


  const fetchMerchants = useCallback(async (pageNo, searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.merchants.getMerchentList(
        { pageNo, pageSize, sort: "desc", sortBy: "id", searchKey },
        token
      );
      
      if (response.success) {
        setMerchants(response.data.result);
        setTotalRows(response.data.totalCount);
      }
      else {
        setMerchants([]);
        setTotalRows(0);
      }
    } catch (error) {
      setMerchants([]);
      setTotalRows(0);
      console.error("Error fetching merchants", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

    useEffect(() => {
          setPage(1);
        // eslint-disable-next-line
      }, [search]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      fetchMerchants(page, search, pageSize);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [page, search, pageSize, fetchMerchants,updateData]);

  
  const closeModal = () => {
    setShowTopUp(false)
    setShowTopUpHistory(false)
    setShowEditMerchantModal(false)
    setShowMerchantInfoModal(false)
  }

    const handleDelete = async (id) => {
      Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to inactive this merchant?",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "rgb(112 110 115)",
            confirmButtonText: "Okay",
          }).then(async (result) => {
            if (result.isConfirmed) {
      try {
        await api.merchants.deleteMerchent({ delete_array: [id], status: false },token);
        toast.success("Merchant deactivated successfully");
        fetchMerchants(page, search, pageSize);
      } catch {
        toast.error("Something went wrong");
      }
  
        }
      });
    };
  
    const handleActivate = async (productId) => {
    Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to activate this merchant?",
            showCancelButton: true,
            confirmButtonColor: "rgb(68, 170, 68)",
            cancelButtonColor: "rgb(112 110 115)",
            confirmButtonText: "Activate",
          }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await api.merchants.deleteMerchent({ delete_array: [productId],"status":true  },token);
              toast.success("Merchant activated successfully");
              fetchMerchants(page, search, pageSize);
            } catch {
              toast.error("Something went wrong");
            }
  
          }
        });
    };


  const columns = [
    { name: "ID", selector: row => row.merchentId, sortable: true, width: "80px" },
    {
      name: region && region.currency
        ? `Merchant Name (${region.currency})`
        : "Merchant Name",
      selector: row => row.merchentName,
      sortable: true
    },
    { name: "Contact Person", selector: row => row.merchentContactPerson, sortable: true },
    { name: "Mobile", selector: row => row.merchentMobile, width: "120px" },
    { 
      name: "Credit Available", 
      selector: row => decimalTo(row.merchentCreditAvalable).toFixed(2), 
      width: "140px" 
    },
    { 
      name: "Status", 
      selector: row => (row.merchentStatus ? "Active" : "Inactive"), 
      cell: row => (
        <span style={{
          padding: "5px 10px", 
          borderRadius: "5px", 
          // color: "#fff", 
          // backgroundColor: row.merchentStatus ? "#44aa44" : "#ff4b4b",
          color: row.merchentStatus ? "#44aa44" : "#ff4b4b",
          display: "inline-block",
          minWidth: "80px",
          textAlign: "center"
        }}>
          {row.merchentStatus ? "Active" : "Inactive"}
        </span>
      ),
      width: "100px"
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
           {role === 1 && (
          <button className="btn btn-primary btn-sm" tyle={{ minWidth: "50px" }}  onClick={() => topUp(row.merchentId, row.merchentName)}>
            Top Up
          </button>
           )}

          {role === 1 && (
          <button className="btn btn-primary btn-sm" style={{ minWidth: "100px" }}  onClick={() => navigate(`/merchants-topup/${row.merchentId}`)}>
            Top Up History
          </button>
           )}

          {row.merchentStatus ? (
          <>
           
          <button className="btn btn-primary btn-sm"  style={{ minWidth: "50px" }} onClick={() => navigate(`/view-merchants/${row.merchentId}`)}>
            View
          </button>
           {role === 1 && (
          <button className="listButton" onClick={() => navigate(`/edit-merchants/${row.merchentId}`)}>
            <FaEdit />
          </button>
           )}

          {role === 1 && (
         <button title="Click to Inactive" className="listButton" onClick={() => handleDelete(row.merchentId)}>
            <FaCircle style={{ fill: 'green' }} />
          </button>
           )}

          </>
          ) : (
            <button title="Click to Active" className="listButton" style={{ minWidth: "80px" }} onClick={() => handleActivate(row.merchentId)}>
                <FaCircle  style={{ fill: 'grey' }} />
              </button>
          )}


        </div>
      ),
      ignoreRowClick: true,

      width: "350px"
    }
  ];
  

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header" >MERCHANTS</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Merchant Name"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
   {role === 1 && (
    <button className="btn new-btn-top btn-primary" style={{ marginLeft: "10px", marginTop: "15px" }}  onClick={() => navigate(`/add-merchants`)}>
      ADD MERCHANTS
    </button>
   )}
        </div>
      </div>
      <DataTable
        columns={columns}
        data={merchants}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        paginationPerPage={pageSize}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage);
        }}
        paginationRowsPerPageOptions={[50, 100,150,200]}
        highlightOnHover
        customStyles={customStyles}
        responsive
        noHeader={false}
        noTableHead={false}
        wrap
      />
       {showTopUp && <TopUp merchentId={mid} showTopUp closeModal={closeModal} setUpdateData={setUpdateData} merchantName={merchantName} />}
    </div>
  );
};

export default MerchantList;
